


























import PdfCommonPayModule from '@/components/common/PdfCommonPayModule.vue'
import VideoHeader from '@/components/VideoHeader.vue'
import ToTop from '@/components/common/ToTop.vue'
import NewVideoInterests from '@/components/NewVideoInterests.vue'

import { defineComponent, onMounted, ref, reactive, computed } from '@vue/composition-api'
import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'

import { VideoHomeService } from './video-home.service'
import { UserService } from '@/services/user.service'
import client from '@/client/'

interface ChangePay {
  id?:number,
  idx?:number,
  sub_mode?:number,
}

export default defineComponent({
  name: 'VideoHome',
  components: {
    PdfCommonPayModule,
    ToTop,
    VideoHeader,
    NewVideoInterests
  },

  setup (props, context) {
    const injector = useReflectiveInjector([VideoHomeService])
    const video = injector.get(VideoHomeService)
    const user = injector.get(UserService)

    const memberShow = computed(() => user.isVideoMember)

    const viewModel = reactive({
      videoPaySetingShow: [111],
      showPayPanel: false,
      isNoScroll: false
    })

    onMounted(() => {
      user.onShowPay.subscribe(() => {
        viewModel.showPayPanel = true
      })
      document.title = '极光视频转换器会员中心'
      // 关闭前上报停留时间
      window.onbeforeunload = () => {
        // @ts-ignore
        const stay_time = parseInt((new Date().getTime() - performance.timing.fetchStart))
        // @ts-ignore
        stayTimeReport({ click: 7, stay_time })
        // @ts-ignore
        localStorage.setItem('video-home-stay-time', stay_time)
      }
    })

    function paySuccess () {
      viewModel.showPayPanel = false
      user.refresh()
    }

    function changePay (obj:ChangePay) {
      report({ hover: obj.idx })
    }

    function loginReport ({ idx }) {
      let clickId = 4
      if (idx && idx !== 9) {
        clickId = 13
      }
      if (idx === 16) {
        clickId = 28
      }
      report({ click: clickId })
    }

    function changeRenew (bool:Boolean) {
      const clickId = bool ? 9 : 8
      report({ click: clickId })
    }

    function toXieyi () {
      report({ click: 10 })
    }

    function changePayType (obj:ChangePay) {
      const clickId = obj.idx + 10
      this.report({ click: clickId })
    }

    function toTop () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    }

    function report ({ click = 0, hover = 0, sub_mode = (context.refs as any)?.payModule?.sub_mode || 0 }) {
      video.reportHomeOperate({ main_click: click, main_hover: hover, sub_mode, user_login: user.isLogin ? 1 : 2 })
    }

    function stayTimeReport ({
      stay_time = 0,
      click = 0,
      hover = 0,
      sub_mode = (context.refs as any)?.payModule?.sub_mode || 0
    }) {
      let user_status = 0
      if (!user.isLogin) {
        user_status = 3
      } else if (user.isDiamondMember || user.isMember || user.isPdfLifeMember || user.isPdfMember || user.isVideoLifeMember || user.isVideoMember) {
        user_status = 1
      } else {
        user_status = 2
      }
      // 上报展示和操作
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        user_login: user.isLogin ? 1 : 2,
        user_status,
        stay_time
      })
    }

    return {
      viewModel,
      memberShow,
      changePayType,
      paySuccess,
      changePay,
      loginReport,
      changeRenew,
      toXieyi,
      toTop
    }
  }
})
